import { formattedDatePtBrToIso } from '@utils/dates/formattedDatePtBrToIso'

import type { DistributeBillingRequestProps } from '@services/api/invoicing/clients/types'
import type { DistributeBillingModalFormProps } from '../components/DistributeBillingModal/form/types'

export const parseDistributeBillingPayload = (formData: DistributeBillingModalFormProps) => {
  const payload: DistributeBillingRequestProps = {
    filiCodigo: formData.filiCodigo,
    cdClienteNl: formData.cdClienteNl,
    fatDtCompetencia: formData.fatDtCompetencia,
    startBillingDate: formData.startBillingDate,
    weekdayPercentage: formData.weekdays ? Number(formData.weekdays) : null,
    saturdayPercentage: formData.saturday ? Number(formData.saturday) : null,
    sundayHolidayPercentage: formData.sunday ? Number(formData.sunday) : null,
    previousMonthBillingDays: formData.invoiceDays ? Number(formData.invoiceDays) : null,
    holidays: !!formData.holidays?.length
      ? formData.holidays?.map((holiday) => formattedDatePtBrToIso(holiday.date)) || null
      : null
  }

  return payload
}
